<header class="flex items-center justify-between border-b border-neutral-gray30 bg-neutral-white px-8 py-5 shadow-sm">
  <div class="flex items-center gap-4">
    <button
      *ngIf="showBackButton"
      (click)="backClick.emit()"
      class="flex items-center justify-center rounded-lg border border-neutral-gray30 px-3 py-2 text-neutral-gray70 hover:bg-neutral-gray10">
      <img src="assets/images/chevron-left.svg" alt="Back" class="h-4 w-4" />
      <span class="ml-2">{{ 'shared.components.header.back' | translate }}</span>
    </button>
    <div class="flex items-center gap-2">
      <h1 class="text-xl font-semibold text-neutral-gray70">{{ title | translate }}</h1>
      <span *ngIf="subtitle" class="rounded bg-neutral-gray20 p-2 text-base font-semibold text-neutral-gray70">
        #{{ subtitle }}
      </span>
    </div>
  </div>

  <div class="flex items-center space-x-4">
    <button
      *ngFor="let button of buttons"
      [id]="button?.id"
      (click)="button?.action()"
      [disabled]="button?.disabled"
      [ngClass]="{
        'bg-primary-90 text-neutral-white hover:bg-primary-70 disabled:bg-[#d8b7d0] disabled:text-white':
          button?.buttonType === 'primary',
        'border border-neutral-gray30 bg-white text-neutral-gray70 hover:bg-neutral-gray10 disabled:bg-neutral-gray10 disabled:opacity-50 disabled:hover:bg-neutral-gray10':
          button?.buttonType === 'secondary'
      }"
      class="flex items-center gap-3 rounded-lg p-3 text-base font-medium tracking-tight shadow transition disabled:cursor-not-allowed">
      <img *ngIf="button?.icon" [src]="button?.icon" alt="icon" class="h-6 w-6" />
      {{ button.label | translate }}
    </button>
  </div>
</header>
